export default "__VITE_ASSET__CYNNUhhb__"